// Ported from vlookup-dramatic/components/faq-band.tsx by scripts/revamp/port-design.js
import React from "react";
import Link from "./link";
import { usePathname } from "../hooks/use-pathname";
import { ArrowUpRight } from "../lib/icons";
import { hiwFaqLink } from "../lib/content";
/*
 * Site-wide "Have more questions?" band, rendered from the root layout so every
 * page carries it directly above the footer. Client-side only so it can read the
 * pathname: the band is hidden on /faq itself, where pointing at the FAQs would
 * be pointing at the page you are already on.
 */
export function FaqBand() {
    const pathname = usePathname();
    if (pathname === hiwFaqLink.href || pathname.startsWith(`${hiwFaqLink.href}/`)) {
        return null;
    }
    return (<section className="border-t border-brand-navy/10 bg-cream-deep">
      <div className="wrap py-10 md:py-12">
        <Link href={hiwFaqLink.href} className="group flex flex-wrap items-center justify-between gap-x-8 gap-y-5">
          <p className="font-display text-2xl font-semibold leading-snug text-brand-navy md:text-4xl">
            {hiwFaqLink.lead}{" "}
            <em className="font-normal italic text-brand-red underline decoration-brand-red/30 decoration-2 underline-offset-8 transition-colors group-hover:decoration-brand-red">
              {hiwFaqLink.cta}.
            </em>
          </p>
          <span className="flex size-12 shrink-0 items-center justify-center rounded-full bg-brand-red text-white transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 md:size-14">
            <ArrowUpRight className="size-6"/>
          </span>
        </Link>
      </div>
    </section>);
}
